import { IGoodInCart } from 'entities/products';
import Image from 'next/image';
import PlaceholderImage from 'assets/images/placeholder_small.png';
import styles from './styles.module.scss';

export const ImagesBlock = ({ goods }: { goods: IGoodInCart[] }) => {
  const goodsImg =
    goods?.map((good) => ({
      img: good?.product?.main_image?.variants?.small?.url || PlaceholderImage,
      quantity: good.quantity,
      price: good.product.price,
    })) || [];

  return (
    <div className={styles.wrapper}>
      {goodsImg.map((good) => (
        <div className={styles.item}>
          <div className={styles.imgHolder}>
            <Image src={good.img} width={100} height={100} alt="изображение товара" />
          </div>
          <p className={styles.price}>
            {good.price} ₽{good.quantity > 1 ? '/шт.' : ''}
          </p>
          <p className={styles.quantity}>{good.quantity} шт.</p>
        </div>
      ))}
    </div>
  );
};
